import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';

import { ChartValueWidgetComponent } from './chart-value-widget/chart-value-widget.component';
import { RankingTableWidgetComponent } from './ranking-table-widget/ranking-table-widget.component';
import { RecommendationTableWidgetComponent } from './recommendation-table-widget/recommendation-table-widget.component';
import { ValueWidgetComponent } from './value-widget/value-widget.component';

@NgModule({
  imports: [SharedModule],
  declarations: [
    ChartValueWidgetComponent,
    RecommendationTableWidgetComponent,
    RankingTableWidgetComponent,
    ValueWidgetComponent,
  ],
  exports: [
    ChartValueWidgetComponent,
    RecommendationTableWidgetComponent,
    RankingTableWidgetComponent,
    ValueWidgetComponent,
  ],
})
export class DashboardWidgetsModule {}
